module.exports = "/**\n * Now we're almost done. Let's do one some fine-tuning.\n */\n\npre:hover{\n  box-shadow: 0px 0px 40px 5px rgba(255,255,255,0.4);\n}\n\n#skip-animation, #pause-resume {\n  display: none;\n}\n\n/**\n * I hope you liked this.\n *\n * Thanks goes to Samuel Reed, from whom I got the idea for this kind of cool homepage.\n * Most of the code behind this is based on his work.\n *\n */\n\n/* END OF SCRIPT */\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./styles4.css
 ** module id = 87
 ** module chunks = 0 1
 **/